"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnvironment = void 0;
const signals_1 = require("@wix/services-definitions/core-services/signals");
const environment_1 = require("./environment");
const createEnvironment = (config, getService) => {
    const env = (0, environment_1.createEnvironment)(config);
    const { signal } = getService(signals_1.SignalsServiceDefinition);
    const languageDirectionSignal = signal(config.languageDirection || 'ltr');
    const metaSiteIdSignal = signal(config.metaSiteId || '');
    const previewModeSignal = signal(config.previewMode || false);
    return {
        ...env,
        getLanguageDirection: () => languageDirectionSignal.get(),
        setLanguageDirection: (direction) => languageDirectionSignal.set(direction),
        getMetaSiteId: () => metaSiteIdSignal.get(),
        setMetaSiteId: (metaSiteId) => metaSiteIdSignal.set(metaSiteId),
        getPreviewMode: () => previewModeSignal.get(),
        setPreviewMode: (previewMode) => previewModeSignal.set(previewMode),
    };
};
exports.createEnvironment = createEnvironment;
//# sourceMappingURL=editorEnvironment.js.map